var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent", staticStyle: { height: "calc(100vh - 50px)" } },
    [
      _c("layout-7", {
        staticStyle: { width: "100%", height: "100%" },
        attrs: {
          id: _vm.pageid,
          term: "",
          title: "Employees",
          binds: [],
          edit_types: [
            null,
            "Value",
            "Value",
            "LocalOffice",
            "EmployeeStatus",
            "DateTime",
            null,
            null
          ],
          edit_perm: "131",
          isAdd: true,
          addDefault: ["N/A", "", "", "", "", "", "", ""]
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43ab19d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43ab19d5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/Edit_Employees.vue
// module id = 717
// module chunks = 0